var map = {
	"./gogo.dark.blue.scss": [
		82,
		42
	],
	"./gogo.dark.green.scss": [
		83,
		43
	],
	"./gogo.dark.orange.scss": [
		84,
		44
	],
	"./gogo.dark.purple.scss": [
		85,
		45
	],
	"./gogo.dark.red.scss": [
		86,
		46
	],
	"./gogo.light.blue.scss": [
		87,
		47
	],
	"./gogo.light.green.scss": [
		88,
		48
	],
	"./gogo.light.orange.scss": [
		89,
		49
	],
	"./gogo.light.purple.scss": [
		90,
		50
	],
	"./gogo.light.red.scss": [
		91,
		51
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 56;
module.exports = webpackAsyncContext;